module.exports = __webpack_public_path__ + "img/popup-game-sucai.26d651fa.png";